// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guide-modules[data-v-3bcda938]{display:flex;flex-direction:column;gap:55px}@media(max-width:1050px){.guide-modules[data-v-3bcda938]{gap:48px}}.guide-modules>div:last-child .divider[data-v-3bcda938]{display:none}", ""]);
// Exports
module.exports = exports;
